import { Flex } from "antd";
import { FC } from "react";
import { formatUAHStandard } from "tm-shared/utils";

import { PrimaryText } from "@/shared/ui/Typography";

import { StyledDebtSummaryHeader } from "./Styled";

interface DebtSummaryHeaderProps {
    totalAmount: number;
    invoicesAmount: number;
}

export const DebtSummaryHeader: FC<DebtSummaryHeaderProps> = ({
    totalAmount,
    invoicesAmount,
}) => {
    return (
        <StyledDebtSummaryHeader>
            <Flex justify="space-between" gap={8}>
                <PrimaryText>Загальна сума:</PrimaryText>
                <PrimaryText fontSize={16}>
                    {formatUAHStandard(totalAmount)}
                </PrimaryText>
            </Flex>
            <Flex justify="space-between" gap={8}>
                <PrimaryText>Сума по накладним:</PrimaryText>
                <PrimaryText fontSize={16}>
                    {formatUAHStandard(invoicesAmount)}
                </PrimaryText>
            </Flex>
        </StyledDebtSummaryHeader>
    );
};
